import React from 'react';
import PropTypes from 'prop-types';
import AdminLoginForm from '../../components/SiteAdmin/AdminLoginForm';
import GET_SITE_SETTINGS from './getSiteSettings.graphql';
import useQueryResponse from '../../lib/hooks/useQueryResponse';

const Login = () => {
  const { data, loading } = useQueryResponse({ query: GET_SITE_SETTINGS });

  let siteName;

  if (!loading && data?.getSiteSettings?.status === 200) {
    const siteSettings = data.getSiteSettings.results?.filter(item => item.name === 'siteName');
    siteName = siteSettings?.[0]?.value;
  }

  return (
    <div>
      {!loading && <AdminLoginForm siteName={siteName} />}
    </div>
  );
};

Login.propTypes = {
  title: PropTypes.string.isRequired,
};

export default Login;